import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

const state = {
    users: [],
    user_details: {
        is_active:  1,
    },
    user_filters: {
        q: '',
        email: '',
        is_admin: '',
    },
    sources: [],
    coupons: [],
}

const actions = {
    searchUser({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/users/search/'+payload.q, {
                params: payload,
            }).then((response) => {
                commit('setUsers', response.data.data.data);
                resolve(response.data.data.data);
            }).catch((e) => {
                console.log('unable to get users', e);
                reject(e);
            })
        });
    },
    getUsers({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoadingStatus', true);
            axios.get('/api/users', {
                params: payload.filters,
            })
                .then((response) => {
                    commit('setUsers', response.data.data);
                    commit('setPagination', response.data.pagination);
                    commit('setLoadingStatus', false);
                    resolve(response.data.data);
                }).catch((e) => {
                console.log('unable to get users', e);
                commit('setLoadingStatus', false);
                reject(e);
            })
        })
    },
    getUser({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoadingStatus', true);
            axios.get('/api/users/'+payload.id).then((response) => {
                commit('setUserDetails', response.data.data);
                resolve(response.data.data);
                commit('setLoadingStatus', false);
            }).catch((e) => {
                console.log('unable to get user', e);
                commit('setLoadingStatus', false);
                reject(e);
            })
        })
    },
    addUser({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/users/add', payload).then((response) => {

                if(response.data && response.data.status == 'ok') {
                    commit('setUserDetails', response.data.data);
                    commit('setSuccessMessage', response.data.message);
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    updateUser({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.put('/api/users/'+payload.id, payload).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setUserDetails', response.data.data);
                    commit('setSuccessMessage', response.data.message);
                } else {
                    console.log('here we are', response.data);
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    deleteUser({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.delete('/api/users/' + payload.id).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setSuccessMessage', response.data.message);

                    if(!payload.list) {
                        commit('setUserDetails', response.data.data);
                    } else {
                        commit('removeUserFromList', payload.id);
                    }
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    updatePassword({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.put('/api/users/'+payload.id+'/change-password', payload).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setSuccessMessage', response.data.message);
                    resolve(response.data.data);
                } else {
                    commit('setErrorMessage', response.data.message);
                }
            }).catch((e) => {
                commit('setErrorMessage', 'Hiba lépett fel a mentés közben!');
                reject(e);
            })
        });
    },
    updateMyAccount({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.put('/api/users/'+payload.id, payload).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setUser', response.data.data);
                    commit('setSuccessMessage', response.data.message);
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                commit('setErrorMessage', 'Hiba lépett fel a mentés közben!');
                reject(e);
            })
        });
    },
}

const mutations = {
    setUsers(state, payload) {
        if(payload) {
            state.users = payload;
        } else {
            state.users = [];
        }
    },
    setUserDetails(state, payload) {
        state.user_details = (payload === null ? { is_active : 1 } : payload);
    },
    removeUserFromList(state, payload) {
        state.users.splice(state.users.indexOf(state.users.find(inv => inv.id == payload)), 1);
    },
    setUserFilters(state, payload) {
        state.user_filters = payload;
    },
}

const getters = {
    users: state => state.users,
    userDetails: state => state.user_details,
    userFilters: state => state.user_filters,
}

export const customerStore = {
    state,
    actions,
    mutations,
    getters
}